import React, { ReactNode, useEffect, useMemo } from 'react'
import { Layout } from '@ui-kitten/components'
import { ScrollView, View, ViewStyle } from 'react-native'
import { BtTitle } from './BtText'
import { useResponsive } from '../hooks'
import { shadow } from '../theme'
import { BtLoading } from './BtLoading'

interface Props {
  navigation?: any
  route?: any
  title: string | ReactNode
  leftTitleAction?: ReactNode
  rightTitleAction?: ReactNode
  headerStyle?: ViewStyle
  children?: ReactNode
  loading?: boolean
  toTopScroller?: any
  header?: ReactNode
  titleCentered?: boolean
  containerStyle?: ViewStyle
  footer?: ReactNode
}

export default ({
  title,
  leftTitleAction,
  rightTitleAction,
  headerStyle,
  children,
  toTopScroller,
  loading,
  header,
  titleCentered = false,
  containerStyle,
  footer,
}: Props) => {
  const { sm } = useResponsive()
  const HEADER_HEIGHT = sm ? 72 : 64
  let scrollView

  useEffect(() => {
    if (scrollView) {
      scrollView.scrollTo({ x: 0, y: 0, animated: true })
    }
  }, [scrollView, toTopScroller])

  const topHeader = useMemo(() => {
    if (header) {
      return header
    }

    return (
      <View
        style={[
          {
            width: '100%',
            flexDirection: 'row',
            alignItems: 'center',
            height: HEADER_HEIGHT,
            paddingHorizontal: sm ? 20 : 10,
          },
          shadow,
          headerStyle,
        ]}
      >
        {leftTitleAction}
        <View style={{ flex: 1, paddingHorizontal: 10 }}>
          {typeof title === 'string' ? (
            <BtTitle
              style={{
                textAlign: titleCentered ? 'center' : 'left',
                flex: 1,
                fontSize: sm ? 20 : 16,
                fontWeight: sm ? '600' : '500',
              }}
            >
              {title}
            </BtTitle>
          ) : (
            title
          )}
        </View>
        {rightTitleAction}
      </View>
    )
  }, [
    header,
    HEADER_HEIGHT,
    sm,
    headerStyle,
    leftTitleAction,
    title,
    titleCentered,
    rightTitleAction,
  ])

  return (
    <Layout style={{ flex: 1 }}>
      {topHeader}
      <ScrollView
        style={{ flexGrow: 1, flex: 1 }}
        contentContainerStyle={[{ padding: sm ? 20 : 10 }, containerStyle]}
        ref={(r) => (scrollView = r)}
      >
        {loading ? <BtLoading /> : children}
      </ScrollView>
      {footer ? footer : null}
    </Layout>
  )
}
